import * as React from 'react';
import cn from 'classnames';

interface CheckboxProps
  extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'type'> {
  className?: string;
}

function Checkbox({ className, ...props }: CheckboxProps) {
  return (
    <input
      type="checkbox"
      data-slot="checkbox"
      className={cn(
        'size-4 shrink-0 cursor-pointer rounded border border-slate-300 dark:border-gray-600 bg-transparent dark:bg-gray-800 text-blue-600 focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 dark:ring-offset-gray-900 disabled:cursor-not-allowed disabled:opacity-50 accent-blue-600',
        className
      )}
      {...props}
    />
  );
}

export { Checkbox };
